import React from "react";
import { ArrowBackCircle, ArrowBackOutline, ArrowForwardOutline } from 'react-ionicons'
import _post from "../Functions/Post"
import SearchFilterFunction from "../Functions/SearchFilter"
import stylesMed from "../MedRep/stylesMed"
import Loading from "../Loading"
import { db } from '../firebase';

export default class ItemsWMS extends React.Component {

    constructor() {
        super();
        this.state = {
            products: [],
            display: [],
            productsCopy: [],
            loading: true,
            noData: true,
            user: "",
            token: "",
            prods: [],
            authenticate: false,
            offset: 0,
            searchValue: "",
            displaycopy: [],
            last: "",
            offline: []

        }
    }

    async componentDidMount() {
        document.body.style.backgroundColor = "#e6e6fa";

        db.enablePersistence();
        var temp = [];
        await db.collection("items").orderBy("item.Code", "asc").limit(4).get().then((querySnapshot) => {
            var lastVisible = querySnapshot.docs[querySnapshot.docs.length - 1];
            console.log("last", lastVisible);

            querySnapshot.forEach((doc) => {

                console.log(doc.data());
                temp.push(doc.data());
            })

        })
        var temp2 = [];

        for (let i = 0; i < 10000; i++) {
            temp2.push({
                "Barcode": this.randomBarcode(), "Code": "ITEM " + ((i) + 1), "Description": "ITEMDESCRIPTION", "Unit": "Peice", "Price": 152, "Size": "Small", "Color": "Red", "Group": "A",
                "Category": "1", "Brand": "Calvin Klein", "Season": "Summer", "Year": "2022", "ShipmentNb": "125478512779589", "Shelf": "1B"
            })
        }
        await this.setState({ products: temp2, productsCopy: temp2, loading: false });
        //    localStorage.setItem("ItemsWMS", JSON.stringify(this.state.products));
        await this.setState({ offline: temp })
    }

    randomBarcode() {
        var result = '';
        var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for (var i = 0; i < 13; i++) {
            result += characters.charAt(Math.floor(Math.random() *
                charactersLength));
        }
        return result;
    }

    readData = async () => {
        var temp = [];
        await db.collection("items").orderBy("item.Code", "asc").limit(4).get().then((querySnapshot) => {
            var lastVisible = querySnapshot.docs[querySnapshot.docs.length - 1];
            console.log("last", lastVisible);

            querySnapshot.forEach((doc) => {

                console.log(doc.data());
                temp.push(doc.data());
            })
            this.setState({ last: lastVisible, displaycopy: temp })
        })



        this.setState({ display: temp, displaycopy: temp })
    }

    readData2 = async () => {
        var temp = [];
        await db.collection("items").get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {

                temp.push(doc.data());
            })

        })



        this.setState({ displaycopy: temp })

    }

    handleAdd = () => {
        this.state.products.map((item) => {
            db.collection("items").add({ item });
            console.log("hi");
        })
    }

    onChangeValue = (e) => {
        this.setState({ searchValue: e.target.value });
    }

    onSearch = async () => {

        var temp = [];
        await db.collection("items").where("item.Barcode", "==", this.state.searchValue).get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {

                console.log(doc.data());
                console.log("hello")
                temp.push(doc.data());
            })

        }).catch((error) => {
            console.log("Error getting documents: ", error);
        });



        this.setState({ display: temp, displaycopy: temp })
    }

    onPrevious = async () => {
        var temp = [];
        await db.collection("items").orderBy("item.Code", "asc").endBefore(this.state.last).limitToLast(4).get().then((querySnapshot) => {
            var firstVisible = querySnapshot.docs[querySnapshot.docs.length - 1];
            console.log("last", firstVisible);

            querySnapshot.forEach((doc) => {

                console.log(doc.data());
                temp.push(doc.data());
            })
            this.setState({ last: firstVisible })
        })



        this.setState({ display: temp, displaycopy: temp })
    }

    onNext = async () => {
        var temp = [];
        await db.collection("items").orderBy("item.Code", "asc").startAfter(this.state.last).limit(4).get().then((querySnapshot) => {
            var lastVisible = querySnapshot.docs[querySnapshot.docs.length - 1];
            console.log("last", lastVisible);

            querySnapshot.forEach((doc) => {

                console.log(doc.data());
                temp.push(doc.data());
            })
            this.setState({ last: lastVisible })
        })



        this.setState({ display: temp, displaycopy: temp })
    }

    render() {
        console.log(this.state.displaycopy)
        if (!this.state.loading) {
            return (
                <div className="container-fluid" style={stylesMed.mainContainer}>
                    <div className="pt-3">
                        <ArrowBackCircle className="btn" onClick={() => this.props.history.push("./LandingPageWMS")} color={'#00bfff'} height="50px" width="50px" />
                    </div>
                    <div className="pt-3">
                        <input type="text" className="form-control" placeholder="Search Here" onChange={this.onChangeValue} />
                    </div>
                    <p className="pt-3 text-center h3">Product List</p>
                    <button onClick={() => this.handleAdd()} > add </button>
                    <button onClick={() => this.readData()} > read </button>
                    <button onClick={() => this.onSearch()} > search </button>
                    <button onClick={() => this.readData2()} > read2 </button>
                    <div className="pt-2">
                        <div className="row">
                            {this.state.display.slice(this.state.offset, this.state.offset + 4).map((item) => {

                                return (
                                    Object.entries(item).map((item2, value) => {

                                        return (


                                            <div className="col-sm-6 pt-3" key={value}>
                                                <div className="card-body bg-light" >
                                                    <h3 className="pt-2">{item2[1].Code}</h3>
                                                    <h5 className="pt-2">Barcode: {item2[1].Barcode}</h5>
                                                    <h5>Price: {item2[1].Price}</h5>
                                                </div>
                                            </div>

                                        )
                                    })
                                )
                            })
                            }
                        </div>
                    </div>


                    <div className="row fixed-bottom" style={stylesMed.mainBackgroundColor}>
                        <div className="col">
                            <ArrowBackOutline className="btn" color={'#00bfff'} height="50px" width="50px" onClick={() => this.onPrevious()} />
                            <h6>Previous Items</h6>
                        </div>
                        <div className="col" style={stylesMed.rightDirection}>
                            <ArrowForwardOutline className="btn" color={'#00bfff'} height="50px" width="50px" onClick={() => this.onNext()} />
                            <h6>Next Items</h6>
                        </div>
                    </div>

                </div >
            );
        }
        else {
            return (
                <Loading history={this.props.history} page={"./LandingPageWMS"} name={"Product"}></Loading>
            )
        }
    }
}

